export const FETCH_METRIC_REQUEST = "FETCH_METRIC_REQUEST";
export const FETCH_METRIC_SUCCESS = "FETCH_METRIC_SUCCESS";
export const FETCH_METRIC_FAILURE = "FETCH_METRIC_FAILURE";
